import { render, staticRenderFns } from "./CardContainerNew.vue?vue&type=template&id=2ef59d8d&scoped=true"
import script from "./CardContainerNew.vue?vue&type=script&lang=ts"
export * from "./CardContainerNew.vue?vue&type=script&lang=ts"
import style0 from "./CardContainerNew.vue?vue&type=style&index=0&id=2ef59d8d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef59d8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef59d8d')) {
      api.createRecord('2ef59d8d', component.options)
    } else {
      api.reload('2ef59d8d', component.options)
    }
    module.hot.accept("./CardContainerNew.vue?vue&type=template&id=2ef59d8d&scoped=true", function () {
      api.rerender('2ef59d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/common/CardContainerNew.vue"
export default component.exports